import React, { useMemo } from "react";
import "./ConfettiOverlay.css";

function ConfettiOverlay({ visible = false, colors = ["var(--sf-green)"] }) {
  const pieces = useMemo(() => {
    if (!visible) return [];
    const total = 140;
    return Array.from({ length: total }).map((_, index) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 3;
      const duration = 6 + Math.random() * 5;
      const size = 6 + Math.random() * 6;
      const rotate = Math.random() * 360;
      const color = colors[index % colors.length];
      return {
        id: index,
        style: {
          left: `${left}%`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
          width: `${size}px`,
          height: `${size * 0.45}px`,
          backgroundColor: color,
          transform: `rotate(${rotate}deg)`,
        },
      };
    });
  }, [visible, colors]);

  if (!visible) {
    return null;
  }

  return (
    <div className="confetti-overlay" aria-hidden="true">
      {pieces.map((piece) => (
        <span
          key={piece.id}
          className="confetti-piece"
          style={piece.style}
        />
      ))}
    </div>
  );
}

export default ConfettiOverlay;

